import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MyAccountClient, User, WebinarFreeWinningDTO, WebinarFreeWinningDTOPagedResult } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
    selector: 'app-winning-webinar-table',
    templateUrl: './winning-webinar-table.component.html',
    styleUrls: ['./winning-webinar-table.component.css'],
    standalone: false
})
export class WinningWebinarTableComponent implements OnInit, OnDestroy {

  // ELEMENT_DATA = [
  //   { image: 1, description: 'Hydrogen' },
  //   { image: 11, description: 'Hydrogen' },
  //   { image: 2, description: 'Helium' },
  //   { image: 3, description: 'Lithium' },
  //   { image: 4, description: 'Beryllium' },
  //   { image: 5, description: 'Boron' },
  //   { image: 6, description: 'Carbon' },
  //   { image: 7, description: 'Nitrogen' },
  //   { image: 8, description: 'Oxygen' },
  //   { image: 9, description: 'Fluorine' },
  // ];
   
  // displayedColumns: string[] = ['image', 'description'];
  
  // dataSource:MatTableDataSource<WebinarFreeWinningDTO>;
  webinars: WebinarFreeWinningDTO[] = [];
  isMobileView = false;
  subscription: Subscription;
  loggedUser: User;
  // dtOptions: any = {};
   
  @ViewChild(MatPaginator) paginator: MatPaginator;

  webinarDivDisplay = 'none';
  
  // Pagination properties
  pageSize = 10;
  pageIndex = 0;
  totalCount = 0;
  pageSizeOptions = [5, 10, 20, 50];
  isLoading = false;

  constructor(
    private myAccountClient: MyAccountClient,
    private customServices: CustomServiceService,
    private commonService: CommonService,
    private router: Router
  ) { }
    
  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.loggedUser = this.customServices.GetLoggedInUser();
    
    // Only load webinars if user is logged in
    if (this.loggedUser && this.loggedUser.id) {
      this.loadWebinars();
    } else {
      console.error('User not logged in');
      this.isLoading = false;
      this.webinarDivDisplay = 'block';
    }
  }

  loadWebinars(): void {
    // Prevent multiple simultaneous requests
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.commonService.setSpinner(true);
    
    // Calculate page number (API uses 1-based page numbers)
    const pageNumber = this.pageIndex + 1;
    
    // Clear previous data while loading
    this.webinars = [];
    
    this.myAccountClient.getWebinarFreeWiningsPaged(this.loggedUser.id, pageNumber, this.pageSize).subscribe({
      next: (response: WebinarFreeWinningDTOPagedResult) => {
        this.webinars = response.data || [];
        this.totalCount = response.totalCount || 0;
        this.webinarDivDisplay = 'block';
        this.isLoading = false;
        this.commonService.setSpinner(false);
      },
      error: (error) => {
        console.error('Error loading webinars:', error);
        this.webinars = [];
        this.totalCount = 0;
        this.isLoading = false;
        this.commonService.setSpinner(false);
        this.webinarDivDisplay = 'block';
      }
    });
  }

  onPageChange(event: PageEvent): void {
    // Update pagination parameters
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    
    // Scroll to top of the list when page changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Reload data with new pagination
    this.loadWebinars();
  }

  OpenWebinar(webinarId: number): void {
    this.router.navigate(['/Webinar', webinarId]);
  }

  isShipped(webinar: WebinarFreeWinningDTO): boolean {
    return (webinar.shippingStatus || '').toLowerCase() === 'shipped';
  }

  get firstName(): string {
    const name = (this.loggedUser?.firstName || '').trim();
    return name || 'there';
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
